// TODO
// - how do we deal with resource type level errors - ie. limit exceeded.
// - in a project return it can uise the "workstations" path. In resources this doesn't exist.
// - unless we have a single POST call for multiple creation  requests.

import { get } from "lodash";
import moment from "moment-timezone";
import { takeLatest, call, all, put, cancel } from "redux-saga/effects";
import { subscribe } from "pusher-redux";

import { getEntitySaga, createEntitySaga } from "./apiSagas.js";

import entityActions from "../reducers/entity/entityActions.js";
import { getISOWeek } from "../../components/forms/formUtils.js";
import {
  getActionEntityByType,
  buildResourceArray
} from "../../utils/utils.js";

import { PUSHER } from "../../constants/pusher.js";
import { RESOURCES } from "../actions/actionConstants.js";
import { apiError } from "../reducers/api/apiActions.js";

export function* resourceByTypeSaga(
  actionEntity,
  id,
  charge,
  usage,
  measurements
) {
  const dependencyAction = {
    type: actionEntity.GET,
    payload: { "@id": id }
  };

  let resource = null;

  try {
    resource = yield call(
      getEntitySaga,
      actionEntity,
      { showErrorModal: false },
      dependencyAction
    );
  } catch (error) {
    yield cancel();
  }

  // abort if no resource was loaded
  // throwing in the apiSaga would be better but requires further testing
  if (!resource) yield cancel();

  if (resource.id) {
    subscribe(
      `private-${resource.id}`,
      PUSHER.EVENTS.UPDATE,
      actionEntity.PUSHER_UPDATE
    );
  }

  const { from, to } = getISOWeek(moment().toISOString());

  // charge, usage and measurements are not required for the SPA to be functional
  if (charge !== false) {
    const chargeId = get(resource, `charge`, null);
    // Individual resource calls display the current month usage data by default
    if (chargeId) {
      const chargeAction = entityActions.getCharge(chargeId, from, to);
      yield put(chargeAction);
    }
  }

  if (usage !== false) {
    const usageId = get(resource, `usage`, null);
    // Individual resource calls display the current month usage data by default
    if (usageId) {
      const usageAction = entityActions.getUsage(usageId, from, to);
      yield put(usageAction);
    }
  }

  if (measurements !== false) {
    const measurementsId = get(resource, `measurements`, null);
    if (measurementsId) {
      const measurementsAction = entityActions.getMeasurements(
        measurementsId,
        from,
        to
      );
      yield put(measurementsAction);
    }
  }

  return resource;
}

function* resourceSaga(action) {
  const actionEntity = getActionEntityByType(action.payload.type);

  const result = yield call(
    resourceByTypeSaga,
    actionEntity,
    action.payload.atId,
    action.payload.charge,
    action.payload.usage,
    action.payload.measurements
  );

  yield put({ type: actionEntity.GET_COMPLETE });

  return result;
}

export function* resourceCreationSaga(action) {
  const { projectId } = action.payload;

  // throw an Error if dependencies are not met
  if (!projectId) {
    throw new Error(
      `Error: projectId is required name: ${action.name} description: ${action.description}`
    );
  }

  // create resource calls
  let resourceCalls = {};

  const resourceList = buildResourceArray(action.payload);

  for (let i = 0; i < resourceList.length; i++) {
    const { data, type, endpoint } = resourceList[i];

    if (data) {
      for (let j = 0; j < data.length; j++) {
        let payload = {
          ...data[j],
          project: projectId,
          endpoint: endpoint,
          fieldPath: `${type}[${j}]`
        };

        resourceCalls[`${i}_${j}`] = call(
          createEntitySaga,
          RESOURCES,
          undefined,
          {
            payload
          }
        );
      }
    }
  }

  // create resources
  let result = null;

  try {
    result = yield all(resourceCalls);
  } catch (error) {
    yield put(apiError(error, false));
    throw error;
  }

  return result;
}

// -- WATCHERS -- //

export function* watchResourceSagas() {
  yield takeLatest(RESOURCES.GET, resourceSaga);
  yield takeLatest(RESOURCES.POST, resourceCreationSaga);
}
